module.exports = __webpack_public_path__ + "static/media/crop-1.e72d613e.jpg";